export const USER_MODULE_NAME = "user"
export const CATEGORY_MODULE_NAME = "category"
export const SUB_CATEGORY_MODULE_NAME = "subCategory"
export const CATALOG_MODULE_NAME = "catalog"
export const EMPLOYEE_MODULE_NAME = "employee"
export const POINTS_MODULE_NAME = "points"
export const TEAMS_MODULE_NAME = "team"
export const SHIFT_MODULE_NAME = "shift"
export const REDEEM_MODULE_NAME = "redeem"
export const ACTIVITY_LOG_MODULE_NAME = "activityLog"



